export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zobrazeno:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["celkem"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Na stránce"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ukázat"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Výsledky"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["z"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obchod"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obchody"])}
}